'use client';

import { c as _c } from "react/compiler-runtime";
import { useAtom } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';
import { useSearchParams } from 'next/navigation';
import { useLocale } from 'next-intl';
import { type ChangeEvent, useEffect } from 'react';
import { useIsMounted } from 'usehooks-ts';
import { currenciesListAtom, currentCurrencyAtom } from '@/features/currency/atoms/currencies-atom';
import { setCookieCurrency } from '@/features/currency/cookies/cookie-currency';
import { type CurrenciesList, type Currency } from '@/features/currency/types/currency-types';
import { LISTINGS_BUDGET_FILTER } from '@/features/listing/constants/listings-filters-constants';
import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import updateLoggedUserLocalization from '@/features/user/requests/update-logged-user-localization';
import { usePathname, useRouter } from '@/i18n/routing';
import { setTypedLocalStorageItem } from '@/shared/utils/typed-local-storage';
import SelectNative from '@/ui/form-elements/select-native/select-native';
interface CurrencySelectProps {
  currencies: CurrenciesList;
  currentCurrency: Currency;
}
export default function CurrencySelect(props) {
  const $ = _c(29);
  const {
    currencies,
    currentCurrency
  } = props;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const locale = useLocale();
  let t0;
  if ($[0] !== currencies) {
    t0 = Object.values(currencies);
    $[0] = currencies;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selectOptions = t0;
  const isMounted = useIsMounted();
  let t1;
  if ($[2] !== currentCurrency) {
    t1 = [currentCurrencyAtom, currentCurrency];
    $[2] = currentCurrency;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== currencies) {
    t2 = [currenciesListAtom, currencies];
    $[4] = currencies;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = [t1, t2];
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useHydrateAtoms(t3);
  const [currency, setCurrency] = useAtom(currentCurrencyAtom);
  const calculateCurrency = _temp;
  let t4;
  if ($[9] !== currencies || $[10] !== currency.name || $[11] !== locale || $[12] !== pathname || $[13] !== router || $[14] !== searchParams || $[15] !== selectOptions || $[16] !== setCurrency) {
    t4 = event => {
      const value_0 = selectOptions.find(option => option.name === event.target.value);
      if (value_0) {
        const previousCurrency = currency.name;
        const selectedRate_0 = currencies[value_0.name].rate;
        const previousRate_0 = currencies[previousCurrency].rate;
        const isUserLogged = getUserBearerCookie();
        if (isUserLogged) {
          updateLoggedUserLocalization(locale, value_0.name).catch(_temp2);
        }
        setCookieCurrency(value_0.name);
        setCurrency(value_0);
        const params = new URLSearchParams(searchParams.toString());
        const budgetMaxParameter = Number(params.get(LISTINGS_BUDGET_FILTER.options.max.name));
        const budgetMinParameter = Number(params.get(LISTINGS_BUDGET_FILTER.options.min.name));
        if (budgetMaxParameter && previousRate_0) {
          const recalculatedMax = String(calculateCurrency(budgetMaxParameter, previousRate_0, selectedRate_0));
          const recalculatedMin = String(calculateCurrency(budgetMinParameter, previousRate_0, selectedRate_0));
          params.set(LISTINGS_BUDGET_FILTER.options.max.name, recalculatedMax);
          params.set(LISTINGS_BUDGET_FILTER.options.min.name, recalculatedMin);
          router.push(`${pathname}?${params.toString()}`);
        } else {
          router.refresh();
        }
        router.refresh();
      }
    };
    $[9] = currencies;
    $[10] = currency.name;
    $[11] = locale;
    $[12] = pathname;
    $[13] = router;
    $[14] = searchParams;
    $[15] = selectOptions;
    $[16] = setCurrency;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const onChangeSelect = t4;
  let t5;
  if ($[18] !== currencies) {
    t5 = () => {
      setTypedLocalStorageItem("currencies", currencies);
    };
    $[18] = currencies;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== currencies || $[21] !== isMounted) {
    t6 = [currencies, isMounted];
    $[20] = currencies;
    $[21] = isMounted;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  useEffect(t5, t6);
  const t7 = currency.name;
  let t8;
  if ($[23] !== selectOptions) {
    t8 = selectOptions.map(_temp3);
    $[23] = selectOptions;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== currency.name || $[26] !== onChangeSelect || $[27] !== t8) {
    t9 = <SelectNative name="currency" label="select website currency" onChange={onChangeSelect} size="sm" hideBorder={true} value={t7}>{t8}</SelectNative>;
    $[25] = currency.name;
    $[26] = onChangeSelect;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}
function _temp3(currencyOption) {
  return <SelectNative.Option key={currencyOption.name} value={currencyOption.name} label={currencyOption.name}>{currencyOption.name}</SelectNative.Option>;
}
function _temp2() {
  return null;
}
function _temp(value, previousRate, selectedRate) {
  if (previousRate !== selectedRate) {
    const inUsd = value / previousRate;
    const maxInCurrentCurrency = inUsd * selectedRate;
    return Math.ceil(maxInCurrentCurrency);
  }
  return value;
}